
class LoadMore extends HTMLElement {
    constructor() {
        super();
        this.initLoadMoreButton();
    }

    initLoadMoreButton() {
        this.button = this.querySelector('button');
        this.spinner = this.querySelector('.load-more-spinner');
        if (this.button) {
            this.button.addEventListener('click', (event) => {
                event.preventDefault();
                //this.spinner.style.display = 'block'
                this.loadMoreProducts();
                this.button.style.display = 'none';
            });
        }
    }

    loadMoreProducts() {
        let productsOnPage = document.querySelector('.collection__products');
        let nextUrl = productsOnPage.getAttribute('data-next-url');

        if (nextUrl) {
            fetch(nextUrl)
            .then(response => response.text())
            .then(nextPage => {
                let tempDiv = document.createElement('div');
                tempDiv.innerHTML = nextPage;
                let newProducts = tempDiv.querySelector('.collection__products');
                productsOnPage.insertAdjacentHTML('beforeend', newProducts.innerHTML);
                
                let newUrl = newProducts.getAttribute('data-next-url');
                productsOnPage.setAttribute('data-next-url', newUrl);
                if (!newUrl) {
                    this.button.style.display = 'none';
                     //this.spinner.style.display = 'block'
                } else {
                    this.initLoadMoreButton();  
                    history.pushState(null, '', nextUrl);
                }
            })
            .catch(error => console.error('Error fetching next page:', error));
        }
    }
}
customElements.define('load-more', LoadMore);

class InfiniteScroll extends HTMLElement {
    constructor() {
        super();
        this.isFetching = false;
        this.productsOnPage = document.querySelector('.collection__products');
        this.nextUrl = this.productsOnPage.getAttribute('data-next-url');
        this.initIntersectionObserver();
    }

    initIntersectionObserver() {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !this.isFetching && this.nextUrl) {
                    this.isFetching = true;
                    this.loadMoreProducts();
                }
            });
        }, {
            root: null,
            threshold: 1.0
        });

        observer.observe(this);
    }

    loadMoreProducts() {
        if (this.nextUrl) {
            fetch(this.nextUrl)
            .then(response => response.text())
            .then(nextPage => {
                let tempDiv = document.createElement('div');
                tempDiv.innerHTML = nextPage;
                let newProducts = tempDiv.querySelectorAll('.collection__products .js-grid > *');

                newProducts.forEach(product => {
                    this.productsOnPage.querySelector('.js-grid').appendChild(product);
                });

                let newNextUrl = tempDiv.querySelector('.collection__products').getAttribute('data-next-url');
                this.nextUrl = newNextUrl;
                this.isFetching = false;

                if (!newNextUrl) {
                    this.nextUrl = null;
                } else {
                    history.pushState(null, '', this.nextUrl);
                }
            })
            .catch(error => {
                console.error('Error fetching next page:', error);
                this.isFetching = false;
            });
        }
    }
}
customElements.define('infinite-scroll', InfiniteScroll);